window.ShiftsAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE? publicConfiguration.TSTeamScheduleServerBaseURL : publicConfiguration.TeamScheduleServerBaseURL;
    _protected.setApiUrl(url);

    /**
     * Creates a new shift
     * @param shift
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.createNewShift = function (shift) {

        var deferred = $q.defer();

        _protected.request("shifts", "POST", shift)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Edit shift
     * @param scheduleShifts
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.editShift = function (shift) {

        var deferred = $q.defer();

        _protected.request("shifts/" + shift.id, "PUT", shift)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Duplicate shifts
     * @param ids of the shifts to duplicate
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.duplicateShifts = function (ids) {

        var deferred = $q.defer();

        _protected.request("/shifts/duplicate", "POST", ids)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Deletes set of shifts
     * @param ids of the shifts to be deleted
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.deleteShifts = function (ids) {

        var deferred = $q.defer();

        _protected.request("/shifts?ids=" + ids.join(','), "DELETE")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };
};